// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";

function title(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.merge([
              Theme__Typography$PrezzeeRibbon.Styles.style6,
              BsCssJs$PrezzeeRibbon.style([
                    BsCssJs$PrezzeeRibbon.color(match.contentCard.descriptionColor),
                    BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrMobile, [
                          BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(14)),
                          BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(25))
                        ])
                  ])
            ]);
}

var Styles = {
  title: title
};

function ContentCard__Description(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    title(theme),
                    className$1
                  ])
            });
}

var make = ContentCard__Description;

export {
  Styles ,
  make ,
}
/* classnames Not a pure module */
